import {AnyAction, Reducer} from 'redux';
import {setMutedActionType} from './actions';

export const isMutedReducer: Reducer<boolean, AnyAction> = (state = false, {type, payload}) => {
    if (type === setMutedActionType) {
        return payload.isMuted;
    }
    return state;
};